var p = Object.defineProperty;
var n = Object.getOwnPropertySymbols;
var h = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
var i = (e, l, t) => l in e ? p(e, l, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[l] = t, d = (e, l) => {
  for (var t in l || (l = {}))
    h.call(l, t) && i(e, t, l[t]);
  if (n)
    for (var t of n(l))
      o.call(l, t) && i(e, t, l[t]);
  return e;
};
var m = (e, l) => {
  var t = {};
  for (var r in e)
    h.call(e, r) && l.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && n)
    for (var r of n(e))
      l.indexOf(r) < 0 && o.call(e, r) && (t[r] = e[r]);
  return t;
};
import * as a from "react";
const g = (r) => {
  var c = r, {
    title: e,
    titleId: l
  } = c, t = m(c, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ a.createElement("svg", d({ width: 32, height: 32, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, t), e ? /* @__PURE__ */ a.createElement("title", { id: l }, e) : null, /* @__PURE__ */ a.createElement("g", { clipPath: "url(#clip0_2880_12267)" }, /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5156 13.0153C15.2309 13.3 14.7692 13.3 14.4844 13.0153L10 8.53087L5.51564 13.0153C5.23088 13.3 4.7692 13.3 4.48444 13.0153C4.19968 12.7305 4.19968 12.2688 4.48444 11.9841L9.48444 6.98408C9.7692 6.69932 10.2309 6.69932 10.5156 6.98408L15.5156 11.9841C15.8004 12.2688 15.8004 12.7305 15.5156 13.0153Z" })), /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", null, /* @__PURE__ */ a.createElement("rect", { width: 20, height: 20 }))));
};
export {
  g as default
};
